import React from 'react';
import { Grid, makeStyles, Typography } from '@material-ui/core';
import { useContent } from '../../../content/content-provider';

const styles = makeStyles(({ palette, spacing }) => ({
  caloriesBannerContainer: {
    backgroundColor: palette.info.light,
    padding: spacing(2),
    minHeight: spacing(15),
    flexDirection: 'row',
    alignItems: 'center',
    display: 'flex',
    overflow: 'hidden',
    justifyContent: 'center',
  },
  bannerText: {
    textAlign: 'center',
    fontSize: '0.75rem',
  },
}));

const CalorieBanner = () => {
  const classes = styles();
  const [content] = useContent();
  const { heading, subHeading } = content.caloriesRDABanner;

  return (
    <Grid container className={classes.caloriesBannerContainer} aria-label="Calories Banner">
      <Typography className={classes.bannerText} variant="h4">
        {heading}
      </Typography>
      <Typography className={classes.bannerText} variant="body1">
        {subHeading}
      </Typography>
    </Grid>
  );
};

export default CalorieBanner;
